import * as types from "../types/pagamentos";

const INITIAL_STATE = {
  pagamento_filtro: {
    titulo: "",
    status: "",
    destaque: "",
    galeria_imagens: "",
  },
  pagamento_page: 1,
  pagamento_perpage: 10,
  pagamento_total: 0,
  pagamento_lista: [],
  pagamento: {},
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_PAGAMENTO:
      return { ...state, pagamento: action.payload };
    case types.LOAD_PAGAMENTOS:
      return { ...state, pagamento_lista: action.payload };
    case types.SET_PAGE_PAGAMENTO:
      return { ...state, pagamento_page: action.payload };
    case types.SET_PERPAGE_PAGAMENTO:
      return { ...state, pagamento_perpage: action.payload };
    case types.SET_TOTAL_PAGAMENTO:
      return { ...state, pagamento_total: action.payload };
    case types.LOADING_PAGAMENTO:
      return { ...state, loading: action.payload };
    case types.SET_FILTRO_PAGAMENTO:
      return {
        ...state,
        pagamento_filtro: { ...state.pagamento_filtro, ...action.payload },
      };
    default:
      return state;
  }
};
